import { useEffect, useState } from 'react';

export const useHeaderHeight = () => {
  const [height, setHeight] = useState('100vh');
  const [headerHeight, setHeaderHeight] = useState('100vh');

    const calculateHeight = () => {
        const headergroupElements = document.querySelectorAll('.shopify-section-group-header-group');
        let totalHeaderHeight = 0;
        headergroupElements.forEach((element, index) => {
            const rect = element.getBoundingClientRect(); // Get the element's position and size relative to the viewport
            const visibleHeight = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0));
            totalHeaderHeight += visibleHeight;
        });

        setHeaderHeight(`${totalHeaderHeight + window.scrollY}px`)
        setHeight(`calc(100vh - ${totalHeaderHeight}px)`);
    };

    useEffect(() => {
        // Add event listeners for scroll and resize
        const handleEvent = () => requestAnimationFrame(calculateHeight);
        window.addEventListener('scroll', handleEvent, { passive: true });
        window.addEventListener('resize', handleEvent);

        // Run calculation after DOM is fully rendered
        const timeout = setTimeout(() => calculateHeight(), 0);

        // Cleanup event listeners on unmount
        return () => {
          window.removeEventListener('scroll', handleEvent);
          window.removeEventListener('resize', handleEvent);
          clearTimeout(timeout);
        };
    }, []);

    return {
        height,
        headerHeight
    };
};
